const initialState = {
  groups: [],
  fetching: false,
};

const fetch = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_AUTHORIZATION_GROUPS_REQUEST':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_AUTHORIZATION_GROUPS_SUCCESS':
      return {
        ...state,
        fetching: false,
        groups: action.groups,
      };

    case 'FETCH_AUTHORIZATION_GROUPS_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    case 'UPDATE_AUTHORIZATION_GROUP_SUCCESS': {
      const groups = state.groups.map((group) =>
        group.groupId === action.group.groupId ? action.group : group
      );

      const group = state.groups.find((f) => f.groupId === action.group.groupId);

      return {
        ...state,
        groups: group ? groups : [...groups, action.group],
      };
    }

    case 'DELETE_AUTHORIZATION_GROUP_SUCCESS':
      return {
        ...state,
        groups: state.groups.filter((g) => g.groupId !== action.groupId),
      };

    default:
      return state;
  }
};

export default fetch;

export const getGroups = (state) => state.groups;

export const isFetching = (state) => state.fetching;
